import './single-investment.scss';
import '../../assets/scripts/libs.jsx';
import '../../components/navigation/navigation.jsx';
import '../../components/footer/footer.jsx';
const galleryItems = document.querySelectorAll('.gallery-item');
const galleryFeatured = document.querySelector('.gallery-featured');

[...galleryItems].forEach(elem => elem.classList.add('filter-grayscale-100'))

galleryItems[0].classList.remove('filter-grayscale-100');

[...galleryItems].forEach(elem => elem.addEventListener('click', () => {
  [...galleryItems].forEach(elem => elem.classList.add('filter-grayscale-100'));
  elem.classList.remove('filter-grayscale-100');
  const src = elem.getAttribute('data-src');

  galleryFeatured.setAttribute('src', src);
}))
